import axios from "axios";
import Vue from "vue";
import store from "../store";
import { returnAppConfig } from "../util/getConfigs";

const baseURL = returnAppConfig().api;

let http = axios.create({
  baseURL,
  timeout: 500000,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
    "Access-Control-Allow-Credentials": true,
  }
});

http.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


http.interceptors.response.use(
  (response) => {
    // success
    Vue.prototype.$loggerApi(response); // pass whole response
    return response;
  },
  (error) => {
    // error (may have error.response OR not)
    Vue.prototype.$loggerApi(error); 

    if (error.response === undefined) {
      console.error('response was undefined. error=' + JSON.stringify(error));
      setTimeout(() => {
        store.state.user.logBox = true;
        store.state.user.logText = "پاسخی از سرور دریافت نشد. اتصال اینترنت را بررسی کنید";
        store.state.user.logErrors = [];
        store.state.user.logStatus = 400;
      }, 200);
    }

    if (error.response?.status === 408 || error.code === "ECONNABORTED") {
      return "timeout";
    }

    return Promise.reject(error);
  }
);

export default http;
